const TAB_ROUTES = {
  menu: 'menu',
  activity: 'activity',
  home: 'home',
  lottery: 'lottery',
  recharge: 'rechargeCont',
  mine: 'mine'
}

const TAB_ROUTE_ALIASES = {
  activity: ['bonus']
}

const TAB_KEYS = ['menu', 'activity', 'home', 'recharge', 'mine']
const PROTECTED_TABS = new Set(['recharge', 'mine'])

function cleanPrefix(prefix) {
  return String(prefix || '').replace(/^\/+|\/+$/g, '')
}

function withPrefix(route, prefix) {
  const clean = cleanPrefix(prefix)
  return `${clean ? `/${clean}` : ''}/${route}`
}

function tabTitle(key, lang = {}) {
  if (key === 'menu') return lang.tab_menu || 'Menu'
  if (key === 'activity') return lang.tab_promotions || lang.Bônus || 'Promotions'
  if (key === 'home') return lang.Início || 'Home'
  if (key === 'lottery') return lang.common_txt138 || 'Lottery'
  if (key === 'recharge') return lang.Depósito || 'Deposit'
  if (key === 'mine') return lang.Meu || 'Mine'
  return key
}

export function buildLayoutTabEntries(prefix, lang = {}) {
  return TAB_KEYS.map((key) => ({
    key,
    title: tabTitle(key, lang),
    to: withPrefix(TAB_ROUTES[key], prefix)
  }))
}

export function activeTabIndexFromPath(path = '') {
  const pathSegments = String(path || '')
    .split('?')[0]
    .split('#')[0]
    .split('/')
    .filter(Boolean)
  const index = TAB_KEYS.findIndex((key) => {
    const routes = [TAB_ROUTES[key], ...(TAB_ROUTE_ALIASES[key] || [])]
    return routes.some((route) => pathSegments.includes(route))
  })
  return index === -1 ? 0 : index
}

export function isProtectedLayoutTab(key) {
  return PROTECTED_TABS.has(key)
}
